import * as React from "react";


export default function Logo() {


    return (
        <div className="logo_home">
            <img src='./images/logo-16-9.jpg' alt="Logo"></img>
            <img src='./images/logoBIrouge.png' alt="Logo"></img>
        </div>
    )
}